import { useEffect, useState } from 'react';

const getMatch = (query) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(query).matches;
};

/**
 * Subscribe to a CSS media query. Returns `true` when it matches.
 * Safe in Jest/jsdom (falls back to `false` when matchMedia is unavailable).
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => getMatch(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return matches;
};

/** Desktop breakpoint shared by the shell (matches Tailwind `lg`). */
export const DESKTOP_QUERY = '(min-width: 1024px)';
export const useIsDesktop = () => useMediaQuery(DESKTOP_QUERY);

export default useMediaQuery;
